import { FieldErrors } from 'react-hook-form';
import { ValidationError } from '../../initializers/yup7';

export type { ValidationError };

/**
 * v7 nests errors ({ a: { b: { message } } }); walk the dot path.
 * Do NOT reuse components/form/utils.getError — its flat bracket-path
 * lookup only matches the v5 error shape.
 */
export const getError = (
  name: string,
  errors: FieldErrors,
): ValidationError | string | undefined => {
  let cursor: any = errors;
  for (const part of name.split('.')) {
    cursor = cursor?.[part];
    if (cursor == null) return undefined;
  }
  return cursor?.message;
};
